export default "__VITE_ASSET__DtnmcBZF__"